import { createTheme } from "@material-ui/core/styles";

declare module "@material-ui/core/styles/createPalette" {
  interface Palette {
    backgroundMainColor: Palette['primary'];
  }
  interface PaletteOptions {
    backgroundMainColor?: PaletteOptions['primary'];
  }
  interface PaletteColor {
    secondary?: string;
  }
  interface SimplePaletteColorOptions {
    secondary?: string;
  }
}

export const darkTheme = createTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#007438",
      secondary: "#0E5C54",
    },
    secondary: {
      main: "#E33E7F",
    },
    background: {
      default: "#121212",
      paper: "#042337",
    },
    text: {
      primary: "#ffffff",
      secondary: "#b0b0b0",
    },
    backgroundMainColor: {
      main: "#033B57",
    },
  },
  typography: {
    fontFamily: '"Heebo", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        body: {
          background: "linear-gradient(180deg, #003D5C 0%, #003551 50%, #002234 75%, #000305 88%, #000000 100%)",
          backgroundAttachment: "fixed",
          minHeight: "100vh",
        },
      },
    },
    MuiButton: {
      root: {
        borderRadius: 45,
      },
    },
    MuiButtonGroup: {
      grouped: {
        "&:not(:first-child)": {
          borderRadius: 0,
        },
        "&:not(:last-child)": {
          borderRadius: 0,
        },
      },
    },
    MuiAppBar: {
      root: {
        background: "linear-gradient(to top, rgba(0, 61, 92, 0) 0%, rgba(0, 61, 92, 1) 100%) !important",
        backdropFilter: "blur(15px)",
        WebkitBackdropFilter: "blur(15px)",
      },
    },
    MuiOutlinedInput: {
      root: {
        backgroundColor: "#042337",
        borderRadius: 8,
        "& fieldset": {
          borderColor: "#555555",
          borderRadius: 8,
        },
        "&:hover fieldset": {
          borderColor: "#007438",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#007438",
        },
      },
      input: {
        backgroundColor: "transparent",
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: (props) => "#042337",
        borderRadius: 8,
        "&:hover": {
          backgroundColor: (props) => "#042337",
        },
        "&.Mui-focused": {
          backgroundColor: (props) => "#042337",
        },
      },
      input: {
        backgroundColor: "transparent",
        color: (props) => "#ffffff",
      },
    },
    MuiLink: {
      root: {
        color: "#218B84",
      },
    },
    MuiListItem: {
      root: {
        backgroundColor: (props) => "#042337",
        color: (props) => "#ffffff",
        "& .MuiTypography-root": {
          color: (props) => "#ffffff",
        },
        "& .MuiListItemIcon-root": {
          color: (props) => "#ffffff",
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        color: "#ffffff",
      },
    },
    MuiDialogActions: {
      root: {
        "& .MuiButton-root": {
          color: (props) => "#ffffff",
        },
      },
    },
  },
  props: {
    MuiTablePagination: {
      labelRowsPerPage: "Rivejä yhteensä",
      labelDisplayedRows: ({ from, to, count }) => `${from}-${to} / ${count}`,
    },
  },
});
